<template>
  <div class="room-cta">
    <button-link outline :link="link" size="md">
      <template v-slot:button-text>{{ $t('pageHome.rooms.cta') }}</template>
      <template v-slot:icon-after>
        <img src="@/assets/icons/ico-chevron-right.svg" alt="" />
      </template>
    </button-link>
  </div>
</template>

<script>
import ButtonLink from '@/components/atomic/ButtonLink.vue';

export default {
  name: 'RoomCTA',
  props: {
    link: {
      type: String,
      default: '/',
    },
  },
  components: {
    ButtonLink,
  },
};
</script>

<style scoped lang="scss">
.room-cta {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 14px;
  }

  .price-text {
    font-family: var(--ff-roboto-sans);
    font-size: 14px;
    color: hsl(var(--clr-primary-700));
  }
}
</style>
